import React from 'react';

import { charts, views, PERIOD_INCOMPATIBLE_VIEWS } from '../../constants/event';
import PeriodChart from '../../chart/period/PeriodChart';

const PeriodsResult = (props) => {
  const { options } = props;

  const periodOptions = PERIOD_INCOMPATIBLE_VIEWS.includes(options.view)
    ? { ...options, view: views.CHART }
    : options;

  return (
    <div>{charts.includes(options.view) && <PeriodChart {...props} options={periodOptions} />}</div>
  );
};

export default PeriodsResult;
